var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectParking1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 1700,
    viewBox: "0 0 2500 1700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M386.543 447.588V145.819H529.418V447.588H386.543Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 5.12558
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M685.109 447.588V145.819H876.678V447.588H685.109Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 5.12558
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 22,
    d: "M694 1203V827H888V1203H694Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 5.12558
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "19-20",
    d: "M1079 1489V827H1266V1489H1079Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 5.12558
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "15-16",
    d: "M1440 1489V827H1631V1489H1440Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 5.12558
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "11-12",
    d: "M1815 1489V827H1986V1489H1815Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 5.12558
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: 5,
    d: "M1460 448V146H1631V448H1460Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 5.12558
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: 7,
    d: "M1821.71 447.588V145.819H2002.38V447.588H1821.71Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 5.12558
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M530.059 447.588V145.819H685.107V447.588H530.059Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 5.12558
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M877.316 447.588V145.819H1068.24V447.588H877.316Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 5.12558
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: 21,
    d: "M888 1203V827H1079V1203H888Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 5.12558
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "17-18",
    d: "M1266 1489V827H1439V1489H1266Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 5.12558
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "13-14",
    d: "M1632 1489V827H1815V1489H1632Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 5.12558
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "9-10",
    d: "M1986 1489V827H2190V1489H1986Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 5.12558
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: 6,
    d: "M1630.78 446.947V145.179H1821.71V446.947H1630.78Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 5.12558
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: 8,
    d: "M2002.38 446.947V145.179H2193.31V446.947H2002.38Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 5.12558
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectParking1);
export default __webpack_public_path__ + "static/media/select-parking-1.7e78a0e9.svg";
export { ForwardRef as ReactComponent };